import {IWayPointCreationWithCorrectionsSingleVoyage} from "@containers/singleVoyage/types/point";
import {moveElementByIndex} from "@helpers/swap";

export const reorderPointsMutateSingleVoyage = ({
                                                    points,
                                                    newPointIndex,
                                                    oldPointIndex
                                                }: {
    points: IWayPointCreationWithCorrectionsSingleVoyage[],
    oldPointIndex: number,
    newPointIndex: number,
}): IWayPointCreationWithCorrectionsSingleVoyage[] => {
    return moveElementByIndex(points,oldPointIndex, newPointIndex)
}
